
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.4 58.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#3C5DBC","d":"M51.4 58.4H7c-3.9 0-7-3.1-7-7V7c0-3.9 3.1-7 7-7h44.4c3.9 0 7 3.1 7 7v44.4c0 3.9-3.1 7-7 7z"}}),_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFF"}},[_c('path',{attrs:{"d":"M32.4 52.7h-.3C18.8 52.7 8 42.2 8 29.2S18.8 5.7 32.1 5.7h.3v9.2h-.3c-8.1 0-14.6 6.4-14.6 14.3s6.6 14.3 14.6 14.3h.3v9.2zM36 32.6c-.3.1-.5.2-1 .2-2.5 0-2.6-2.4-2.6-2.4v-4l.1-.5h5.1v4c-.1 0-.2 2.1-1.6 2.7zM48.9 32.6c-.3.1-.5.2-1 .2-2.4 0-2.6-2.4-2.6-2.4v-4l.1-.5h5.1v4c-.1 0-.2 2.1-1.6 2.7zM42.1 40.7c-.2.1-.4.1-.7.1-2.4 0-2.6-2.3-2.6-2.3v-4 .4H44v4c0-.1-.2 1.3-1.9 1.8zM42.4 32.6c-.3.1-.5.2-1 .2-2.4 0-2.6-2.4-2.6-2.4v-4.5H44v4s-.2 2.1-1.6 2.7zM42.1 24.7c-.2.1-.4.1-.7.1-2.4 0-2.6-2.4-2.6-2.4v-4.1H44v4s-.2 2-1.9 2.4z"}})])])
          )
        }
      }
    